var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"c-topic-card",style:({'background-image': `url(${_vm.logo})`}),on:{"click":_vm.gotoDetail}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.topic.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }